import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { get } from '../../../core/client';
import { IFeed, IMenuListPayload, IReportGridExcel, IResultOptions } from './model';
import { downloadFile } from '../../../_helpers/useful-functions';

export const getMomentReportMenuList: any = createAsyncThunk('report-panel/menu-List', async ({ startDate, endDate, companyList }: IFeed) => {
    const url = `/report-panel/menu-List?CompanyCodeList=${companyList}` + (startDate && endDate ? `&StartDate=${startDate}&EndDate=${endDate}` : ``);
    const momentReportMenuList = await get<any>(url);
    return momentReportMenuList;
});
export const getMomentReportCompanyList: any = createAsyncThunk('/report-panel/company-List', async () => {
    const momentReportCompanyList = await get<any>('/report-panel/company-List');
    return momentReportCompanyList;
});
export const getMomentReportsDashboardFeed: any = createAsyncThunk(
    '/report-panel/dasboardFeed',
    async ({ startDate, endDate, companyList }: IFeed) => {
        const url =
            `/report-panel/moments-company-based-report?CompanyCodeList=${companyList}` +
            (startDate && endDate ? `&StartDate=${startDate}&EndDate=${endDate}` : ``);
        const momentReportsFeed = await get<any>(url);
        return momentReportsFeed;
    },
);
export const getMomentReportsGropuTitleGrid: any = createAsyncThunk(
    '/report-panel/Moment-Reports-GropuTitleGrid',
    async ({ startDate, endDate, serviceUrl, companyIdList, type, pageSize, pageIndex = 0 }: IFeed) => {
        const url =
            `${serviceUrl}?CompanyCodeList=${companyIdList}&type=${type}` +
            (startDate && endDate ? `&StartDate=${startDate}&EndDate=${endDate}` : ``) +
            `&pageSize=${pageSize}&pageIndex=${pageIndex}`;
        const momentReportsGropuTitleGrid = await get<any>(url);
        return momentReportsGropuTitleGrid;
    },
);

export const downloadMomentReportsExcel: any = createAsyncThunk(
    'report-panel-excel/report-global-excel',
    async ({ startDate, endDate, companyIdList, reportLeftMenuDetailsType }: IReportGridExcel) => {
        const url =
            `report-panel-excel/report-global-excel?CompanyCodeList=${companyIdList}&ReportLeftMenuDetailsType=${reportLeftMenuDetailsType}` +
            (startDate && endDate ? `&StartDate=${startDate}&EndDate=${endDate}` : ``)
       await downloadFile(url)
       return
    },
);

const momentReportsSlice = createSlice({
    name: 'moment-reports',
    initialState: {
        reports: {
            id: null,
            title: '',
        },
        momentReportsMenuList: {
            loading: true,
            items: [],
        },
        companyList: {
            loading: true,
            items: [],
        },
        companyAllListWithLabelValue: {
            loading: true,
            items: [],
        },
        reportFilter: {
            companyList: [],
            startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
            endDate: new Date(),
            companyIdList: [],
            companyNameList: [],
        },
        dasboardFeed: {
            items: [],
            loading: true,
        },
        notifications: {
            loading: true,
            name: '',
            count: null,
        },
        reportTable: {
            loading: true,
            items: [],
            name: '',
            count: null,
        },
        notficationType: null,
        page: {
            subPage: 'dashboard-feed',
            pageMenuType: null,
        },
        isFilterTouch: false,
        isValidate: false,
        feedBoxData: [],
        yellowWarning: {
            startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
            endDate: new Date(),
            companyNameList: [],
        },
        isSwipeModalFilterSelections: false,
        checkboxValue: null,
        gridTableGroupTitle: {
            startDate: null,
            endDate: null,
            companyIdList: [],
            leftMenuDetailsType: null,
            serviceUrl: null,
            loading: false,
            type: null,
            excelType: null,
            pageIndex: 0, //! sayfa indexi
            pageSize: 50,
        },
        filterModalOpen: false,
        groupTitleGridTable: {
            loading: true,
            rowList: [],
            buttonList: [],
            headerList: [],
            totalCount: 0,
            totalPages: 0,
            pageIndex: 0,
            indexFrom: 0,
            hasNoData: false,
        },
    },
    reducers: {
        setReportTitle(state, action) {
            state.reports = action.payload;
        },
        setReportFilter(state, action) {
            state.reportFilter = action.payload;
        },

        setNotificationTitle(state, action) {
            state.notifications.name = action.payload;
        },
        setNotificationType(state, action) {
            state.notficationType = action.payload;
        },
        setSubPage(state, action) {
            state.page.subPage = action.payload;
        },
        setPageMenuType(state, action) {
            state.page.pageMenuType = action.payload;
        },
        setIsFilterTouch(state, action) {
            state.isFilterTouch = action.payload;
        },
        setIsFilterValidate(state, action) {
            state.isValidate = action.payload;
        },
        setFeedCardData(state, action) {
            state.feedBoxData = action.payload;
        },
        setCompanyListToReportFilter(state, action) {
            state.reportFilter.companyList = action.payload;
        },
        setYellowWarning(state, action) {
            state.yellowWarning = action.payload;
        },
        setCheckboxValue(state, action) {
            state.checkboxValue = action.payload;
        },
        setGroupTitle(state, action) {
            state.gridTableGroupTitle = action.payload;
        },
        setGridPageIndex(state, action) {
            state.gridTableGroupTitle.pageIndex = action.payload;
        },
        setGridPageIndexToZero(state) {
            state.gridTableGroupTitle.pageIndex = 0;
        },
        setFilterOpen(state, action) {
            state.filterModalOpen = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(getMomentReportMenuList.fulfilled, (state, action: IMenuListPayload) => {
            state.momentReportsMenuList.items = action.payload.isSuccessful ? action.payload.result.items : [];
            state.momentReportsMenuList.loading = false;
        });
        builder.addCase(getMomentReportCompanyList.pending, state => {
            state.companyList.loading = true;
        });
        builder.addCase(getMomentReportCompanyList.fulfilled, (state, action: PayloadAction<IResultOptions>) => {
            state.companyList.items = action.payload.isSuccessful ? action.payload.result.items : [];
            state.companyList.loading = false;

            const companyData = [];
            for (let i = 0; i < action?.payload?.result?.items.length; i++) {
                const element = action?.payload?.result?.items[i];
                companyData.push({
                    label: element?.name,
                    value: element?.id,
                });
            }
            state.companyAllListWithLabelValue.items = companyData;
            state.companyAllListWithLabelValue.loading = false;
        });
        builder.addCase(getMomentReportsDashboardFeed.pending, state => {
            state.dasboardFeed.loading = true;
            state.groupTitleGridTable.hasNoData = false;
        });
        builder.addCase(getMomentReportsDashboardFeed.fulfilled, (state, action: PayloadAction<IResultOptions>) => {
            state.dasboardFeed.items = action.payload.isSuccessful ? action.payload.result.items : [];
            state.dasboardFeed.loading = false;
            state.groupTitleGridTable.hasNoData = action.payload.isSuccessful && action?.payload?.result?.items?.length === 0;
        });

        builder.addCase(getMomentReportsGropuTitleGrid.pending, state => {
            state.groupTitleGridTable.loading = true;
            state.groupTitleGridTable.hasNoData = false;
        });
        builder.addCase(getMomentReportsGropuTitleGrid.fulfilled, (state, action: PayloadAction<IResultOptions>) => {
            state.groupTitleGridTable.headerList = action.payload.isSuccessful ? action.payload.result.item?.items1 : [];
            state.groupTitleGridTable.rowList = action.payload.isSuccessful ? action.payload.result?.item?.items2 : [];
            state.groupTitleGridTable.buttonList = action.payload.isSuccessful ? action.payload.result?.item?.items3 : [];
            state.groupTitleGridTable.totalCount = action.payload.isSuccessful ? action.payload.result?.item?.totalCount : null;
            state.groupTitleGridTable.totalPages = action.payload.isSuccessful ? action.payload.result?.item?.totalPages : null;
            state.groupTitleGridTable.pageIndex = action.payload.isSuccessful ? action.payload.result?.item?.pageIndex : 0;
            state.groupTitleGridTable.loading = false;
            state.groupTitleGridTable.hasNoData =
                action.payload.isSuccessful && action.payload.result.item?.items1?.length === 0 && action.payload.result.item?.items2?.length === 0;
            state.gridTableGroupTitle.pageIndex = 0;
        });
    },
});

export default momentReportsSlice.reducer;
export const {
    setCompanyListToReportFilter,
    setFeedCardData,
    setIsFilterValidate,
    setIsFilterTouch,
    setReportTitle,
    setReportFilter,
    setNotificationTitle,
    setNotificationType,
    setSubPage,
    setPageMenuType,
    setYellowWarning,
    setCheckboxValue,
    setGroupTitle,
    setGridPageIndex,
    setGridPageIndexToZero,
    setFilterOpen,
} = momentReportsSlice.actions;
